import axios from "axios";

const ENV_URL = process.env.REACT_APP_API_URL;

//Login node api
export const NodeLogin = async ({ user, token }) => {
  const URL = `${ENV_URL}/companyDashboard/login`;
  try {
    const { data } = await axios({
      method: "post",
      url: URL,
      data: user,
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
//CADASTRA UM ESTABELECIMENTO EM APROVAÇÃO
export const setNewEstablishment = async ({ establishment, token }) => {
  const URL =
    `${ENV_URL}/companyDashboard/establishment`;
  try {
    const { data } = await axios({
      method: "post",
      url: URL,
      data: establishment,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

// UPDATE ESTABLISHMENT
export const updateEstablishment = async ({ id, token, body }) => {
  const URL = `${ENV_URL}/companyDashboard/establishment/${id}`;
  try {
    const { data } = await axios({
      method: "PATCH",
      url: URL,
      data: body,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

// REGISTRAR CONTRATO

export const pushContractEstablishment = async ({ id, token, formData }) => {
  const URL = `${ENV_URL}/companyDashboard/establishmentContract/${id}`;
  try {
    const { data } = await axios({
      method: "POST",
      url: URL,
      data: formData,
      headers: { authorization: token, "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

//REGISTRAR BENEFICIO

export const pushDiscountEstablishment = async ({ id, token, array }) => {
  const URL = `${ENV_URL}/companyDashboard/establishmentBenefits/${id}`;
  try {
    const { data } = await axios({
      method: "POST",
      url: URL,
      data: array,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

//REGISTRO DE ENDEREÇO

export const pushAddressEstablishment = async ({ id, token, array }) => {
  const URL = `${ENV_URL}/companyDashboard/establishmentAddress/${id}`;
  try {
    const { data } = await axios({
      method: "POST",
      url: URL,
      data: array,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

// REGISTRO DE IMAGENS

export const pushImageEstablishment = async ({ id, token, FormData, type }) => {
  const URL = `${ENV_URL}/companyDashboard/establishmentImage/${id}?type=${type}`;
  try {
    const { data } = await axios({
      method: "POST",
      url: URL,
      data: FormData,
      headers: { authorization: token, "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getNodeCategories = async () => {
  const URL = `${ENV_URL}/locations/categories`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getNodeStates = async () => {
  const URL = `${ENV_URL}/locations/states`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getNodeCities = async (state) => {
  const URL = `${ENV_URL}/locations/cities/${state}`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const postNodeEmail = async ({ token, id }) => {
  const URL = `${ENV_URL}/companyDashboard/establishmentEmail/${id}`;
  try {
    const { data } = await axios({
      method: "POST",
      url: URL,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getMyEstablishments = async ({ token, page, limit }) => {
  const URL = `${ENV_URL}/companyDashboard/establishment?page=${Number(page) - 1 || 0
    }&limit=30`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: { authorization: token },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getProducts = async (token) => {
  const URL = `${ENV_URL}/companyDashboard/products`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlans = async (token) => {
  const URL = `${ENV_URL}/companyDashboard/plans`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


